export const website = {
  firstStep: {
    title: "C'est parti ! Quel modèle souhaitez-vous utiliser ?",
    subtitle:
      "Prêt à créer un site web magnifique ? Commençons par les modèles ; nous passerons ensuite aux couleurs.",
  },
  secondStep: {
    title: "Quelle gamme de couleurs correspond le mieux à votre marque ?",
    subtitle: "Personnalisez votre modèle avec une touche de couleur",
  },
  thirdStep: {
    title: "Avez-vous de belles photos de votre propriété ?",
    titleLine2: "Téléchargez-les !",
    subtitle: "Téléchargez la meilleure photo de votre propriété pour la page d'accueil",
  },
  fourthStep: {
    title: "Parfait. Et si vous choisissiez un nom pour votre entreprise ?",
    subtitle:
      "Le nom et le slogan d'une entreprise renforcent la reconnaissance et consolident votre image de marque.",
  },
  fifthStep: {
    title: "Avez-vous un logo pour votre marque ?",
    subtitle:
      "Pour de meilleurs résultats, utilisez un design vectoriel ou un PNG à fond transparent. Les ratios idéaux sont 2:1 ou 1:1 (image carrée). La taille doit être de 400 px x 192 px (hauteur min. 60 px). Si vous n'avez pas encore de logo, nous utiliserons le nom de votre entreprise comme marque.",
  },
  livingstone: {
    navMain: "Menu principal",
    navProperty: "Propriété",
    navMap: "Carte",
    navGallery: "Galerie",
    navRates: "Tarifs",
    navAvailability: "Disponibilité",
    navReviews: "Avis",
    bookNow: "Réserver maintenant",
    checkinCheckout: "Arrivée → Départ",
    guests: "Voyageurs",
  },
  tideway: {
    navMain: "Menu principal",
    navProperty: "Propriété",
    navMap: "Carte",
    navGallery: "Galerie",
    navRates: "Tarifs",
    navAvailability: "Disponibilité",
    navReviews: "Avis",
    bookNow: "Réserver maintenant",
    checkinCheckout: "Arrivée → Départ",
    guests: "Voyageurs",
  },
};
